import { render, staticRenderFns } from "./hot-pro.vue?vue&type=template&id=c69f4ad2&scoped=true&"
import script from "./hot-pro.vue?vue&type=script&lang=js&"
export * from "./hot-pro.vue?vue&type=script&lang=js&"
import style0 from "./hot-pro.vue?vue&type=style&index=0&id=c69f4ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69f4ad2",
  null
  
)

export default component.exports